// loading.js
import { Spin } from 'ant-design-vue';
import { createVNode, render } from 'vue';

// 创建容器并添加到body
const container = document.createElement('div');
// 给容器添加唯一类名，方便设置样式
container.className = 'loading-container';
document.body.appendChild(container);

// 计数管理
let loadCount = 0;

// 创建Spin组件
const spinVNode = createVNode(Spin, {
  spinning: false,
  tip: '加载中...',
  size: 'large',
  fullscreen: true, // 不使用内置全屏，改为自定义全屏样式
  class: 'custom-spin'
}, null);

// 初始渲染
render(spinVNode, container);

// 添加全局样式
const style = document.createElement('style');
style.textContent = `
  .loading-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999; /* 确保在最上层 */
    display: none; /* 默认隐藏 */
    background-color: rgba(255, 255, 255, 0.7);
  }
  
  .loading-container.visible {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .custom-spin {
    /* 可以调整加载动画的大小和颜色 */
  }
`;
document.head.appendChild(style);

// 显示加载
export const showSpin = () => {
  loadCount++;
  container.classList.add('visible');
  spinVNode.component.props.spinning = true;
};

// 隐藏加载
export const hideSpin = () => {
  if (loadCount > 0) {
    loadCount--;
  }
  if (loadCount === 0) {
    container.classList.remove('visible');
    spinVNode.component.props.spinning = false;
  }
};
